import Vue from "vue";
import Vuex from "vuex";
import config from "@/assets/config.json";

// 通用Module

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },
  getters: {},
  mutations: {},
  modules: {},
  actions: {
    // 发送邮件
    submitEmail({
      rootState
    }, opt) {
      return new Promise((resolve, reject) => {
        axios.post(`${config.api.api}/octomore-sms/octomore/mail`, opt, rootState.header)
          .then(({
            data
          }) => {
            if (data) {
              resolve(data);
            }
          });
      }).catch(err => {
        console.log(err);
      })
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js